// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import './resources/configure' // initializes http config and token handling
import Toast from './services/toast'
import Ads from 'vue-google-adsense'

//Vue.use(require('vue-script2'))

Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)


window.Toast = Toast; // Toast can be used anywhere now.

// Register global components
Vue.component('PageHeader', require('./components/shared/PageHeader'))
Vue.component('Help', require('./components/shared/panels/Help'))
Vue.component('Panel',              require('./components/shared/panels/Panel'))
Vue.component('PanelHeading',       require('./components/shared/panels/Heading'))
Vue.component('PanelBody',          require('./components/shared/panels/Body'))
Vue.component('LoadingIndicator', require('./components/shared/LoadingIndicator'))
Vue.component('DynamicTable', require('./components/shared/tables/DynamicTable'))

// Import Global directives
import './directives/index'


/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  template: '<App />',
  components: { App },
})



// WEBPACK FOOTER //
// ./src/main.js